import { Breadcrumb, Button } from 'antd';
import React from 'react';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';

interface GeneralHeaderProps {
  btnComponent: React.ReactNode;
  child: React.ReactNode;
  icon: string;
  pageTitle: string;
  showBreadcrumb: boolean;
  status: string;
  isPersonal?: boolean;
  topIcon?: any;
}
const GeneralHeader = (props: Partial<GeneralHeaderProps>) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user_id } = useParams();

  const pathSnippets = location.pathname
    .split('/')
    .filter((i) => i)
    .filter((item) => item !== user_id);

  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`;
    const pathName = _.replaceAll('_', ' ');

    return {
      key: url,
      title: (
        <Link
          to={url}
          style={{
            textTransform: 'capitalize',
            color:
              url === location.pathname || index + 1 === pathSnippets?.length
                ? '#757575'
                : '#0E3063',
            fontSize: '16px',
            pointerEvents:
              url === location.pathname || index + 1 === pathSnippets?.length
                ? 'none'
                : 'auto',
            cursor: url === location.pathname ? 'not-allowed' : 'pointer',
            fontWeight: url === location.pathname ? 500 : 600,
          }}
          state={{
            ...location.state,
          }}
        >
          {pathName === 'hr tracking'
            ? 'hR tracking'
            : pathName === 'departments'
            ? 'Organization'
            : pathName}
        </Link>
      ),
    };
  });
  // list.map() => box
  const breadcrumbItems = [
    {
      title: (
        <Link
          to="/"
          style={{ color: '#0E3063', fontSize: '16px', fontWeight: 600 }}
        >
          Homepage
        </Link>
      ),
      key: 'home',
    },
  ].concat(extraBreadcrumbItems);
  return (
    <div
      style={{
        background: `url('/assets/header_background.svg')`,
        height: '42vh',
        padding: '2rem 3rem',
        paddingBottom: props?.isPersonal && '0',
      }}
    >
      <div className={'flex_center'}>
        <Button type={'link'} onClick={() => navigate(-1)}>
          <img src={'/icons/back.svg'} alt={'icon'} />
        </Button>
        {props.showBreadcrumb !== false && (
          <Breadcrumb items={breadcrumbItems} className="breadcrumb_custom" />
        )}
      </div>
      <div
        className={!props?.isPersonal ? 'flex_between_center' : ''}
        style={{ marginTop: '2rem' }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignContent: 'center',
            alignItems: 'center',
          }}
        >
          {props.icon && (
            <img src={props.icon} alt={'icon'} width={32} height={32} />
          )}
          <span
            style={{
              marginLeft: props.icon ? '0.95rem' : '',
              fontWeight: 700,
              fontSize: '24px',
              color: '#000000',
              // marginTop: 20,
            }}
          >
            {props.pageTitle}
          </span>
          <div>
            {props.status === 'approved' ? (
              <img
                style={{ marginLeft: '10px', marginRight: -10 }}
                alt="x"
                src="/icons/approved.svg"
              />
            ) : props.status === 'cancelled' ? (
              <img
                style={{
                  marginLeft: '10px',
                  marginBottom: '4px',
                  marginRight: -10,
                  height: 24,
                  width: 24,
                }}
                alt="x"
                src="/icons/cancelled_icon.svg"
              />
            ) : (
              ''
            )}
            <span
              style={{
                marginLeft: 10,
                fontSize: 16,
                fontWeight: 500,
                color:
                  props.status === 'to_be_approved'
                    ? '#2C5EE0'
                    : props.status === 'approved'
                    ? '#26BE48'
                    : props.status === 'rejected'
                    ? '#E02C2C'
                    : props.status === 'cancelled'
                    ? '#E02C2C'
                    : '',
              }}
            >
              {props.status === 'to_be_approved'
                ? 'To be approved'
                : props.status === 'approved'
                ? 'Approved'
                : props.status === 'rejected'
                ? 'Rejected'
                : props.status === 'cancelled'
                ? 'Cancelled'
                : ''}
            </span>
          </div>
          {props.topIcon}
        </div>

        <div>{props.btnComponent}</div>
      </div>
      <section className="style_tab">{props.child}</section>
    </div>
  );
};

export default GeneralHeader;
